
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import { verifyMoney } from "@common/src/utils/verify";
import CouponPreview from "./components/coupon-preview.vue";
import appCode from "@common/src/utils/app-code";
import t from "@common/src/i18n/t";
import { InjectFunction } from "@common/src/utils/decorator";
import SwitchAutoTips from "../components/switch-auto-tips.vue";

const user = namespace("user");
const coupon = namespace("coupon");
const parts = namespace("parts");
const base = namespace("base");
const app = namespace("app");

@InjectFunction("dayjs", "permitApp")
@Component({ components: { CouponPreview, SwitchAutoTips } })
export default class CreatedCoupon extends Vue {
  @user.State userData;
  @user.State selectedOrgCode;
  @base.Action getDictionaryList;
  @coupon.Action orderUnconditional; // 无门槛
  @coupon.Action orderReachedAmount; // 订单满减
  @coupon.Action productUnconditional; //商品无门槛优惠券
  @coupon.Action productReachedAmount; //商品满金额优惠券
  @coupon.Action serviceUnconditional; //服务无门槛优惠券
  @coupon.Action queryOpCouponList;
  @app.State autoPopOpTemplate;
  @parts.Action getPartsList;
  @coupon.Action queryServiceItemList;
  @coupon.Action getDetail;
  @Watch("couponForm.rewardType")
  couponFormRadio() {
    if (this.couponForm.rewardType === "0401") {
      this.couponForm.radioNumber = "";
    } else {
      this.couponForm.radioNumberYuan = "";
    }
  }
  createCouponMethodList = [];
  showDialog: boolean = true;
  active = 0;
  partsOptions = [];
  couponType = {
    "0101": 0,
    "0102": 1,
    "0201": 2,
    "0202": 3,
    "0301": 4
  };
  couponTypeArr: any = ["0101", "0102", "0201", "0202", "0301"];
  project = [];
  fiveBox = [
    { title: t("v210831.no-threshold-coupon"), details: t("v210831.unconditionally-discount-or-discounts") },
    { title: t("v210831.order-full-amount-coupon"), details: t("v210831.discount-or-discount") },
    { title: t("v210831.specified-product-coupons"), details: t("v210831.discount-or-discount-assign") },
    { title: t("v210831.specified-product-full"), details: t("v210831.discount-or-discount-assign-full") },
    { title: t("v210831.specify-project-coupons"), details: t("v210831.discount-or-discount-service-time") }
  ];
  couponForm: any = {
    activityName: "",
    totalQuantity: "",
    activityDesc: "",
    rewardType: "0401",
    radioNumber: "",
    radioNumberYuan: "",
    activityBegin: "",
    activityEnd: "",
    limitAmount: "",
    slectedParts: [],
    multipleProject: [],
    rewardValue: "", // 优惠数值
    productDetails: [],
    activityCode: "",
    time: [],
    couponType: "",
    storeTypeList: []
  };
  searchData = {
    pageNum: 1,
    pageSize: 20,
    searchKey: ""
  };
  loading = false;
  radioNumberRuleYuan = (rule, value, callback) => {
    console.log(this.couponForm);
    if (this.couponForm.rewardType === "0402") {
      return callback();
    }
    if (!this.couponForm.radioNumberYuan) {
      callback(new Error(t("v210831.please-enter-the-discounts-content")));
    } else if (verifyMoney(value)) {
      callback();
    } else {
      callback(new Error(t("v210831.it-must-be-positive-integer-fixed-2")));
    }
  };
  radioNumberRule = (rule, value, callback) => {
    if (this.couponForm.rewardType === "0401") {
      return callback();
    }
    if (!this.couponForm.radioNumber) {
      callback(new Error(t("v210831.please-enter-the-discounts-content")));
    } else {
      let patt = /^(?=0\.[1-9]|[1-9]\.\d).{3}$|^([1-9])$/;
      if (patt.test(value)) {
        callback();
      } else {
        callback(new Error(t("v210831.you-can-enter-0-10-fixed-2")));
      }
    }
  };
  callValue(value, callback) {
    if (this.active !== 1 && this.active !== 3) {
      callback();
    } else {
      callback(new Error(t("v210831.please-enter-the-doorsill-amount")));
    }
  }
  doorsillYuan = (rule, value, callback) => {
    if (!value) {
      this.callValue(value, callback);
    } else {
      // priceRulesEl(value, callback);
      if (verifyMoney(value)) {
        callback();
      } else {
        callback(new Error(t("v210831.it-must-be-fixed-2-max")));
      }
    }
  };
  opCouponList: any = [];
  showSelectOpTemplate: boolean = false;
  handleSelectTemplate() {
    this.showSelectOpTemplate = true;
  }
  handleConfirmTemplate() {
    this.showSelectOpTemplate = false;
    this.couponInfoSet(this.selectedTemp, "quote");
  }
  multipleValueVerity(value, callback) {
    if (this.active !== 2 && this.active !== 3) {
      callback();
    } else if (!value || !value.length) {
      callback(new Error(t("setting.select-spare-parts")));
    } else {
      callback();
    }
  }
  multipleValueArr = (rule, value, callback) => {
    this.multipleValueVerity(value, callback);
  };
  multipleProjectVerity(value, callback) {
    if (this.active !== 4) {
      callback();
    } else if (!value || !value.length) {
      callback(new Error(t("v210801.pls-select-project")));
    } else {
      callback();
    }
  }
  multipleProjectArr = (rule, value, callback) => {
    this.multipleProjectVerity(value, callback);
  };
  multipleTotalQuantity = (rule, value, callback) => {
    if (!value) {
      callback(new Error(t("v210831.please-enter-a-integer")));
    } else {
      this.integerTest(value, callback);
    }
  };
  integerTest(value, callback) {
    let reg = /^[1-9]\d*$/;
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error(t("v210831.please-enter-a-integer")));
    }
  }

  endTiemVerify = (rule, value, callback) => {
    if (!value) {
      callback(t("v210831.please-select-the-start-time"));
    } else if (this.couponForm.activityBegin > this.couponForm.activityEnd) {
      callback(new Error(t("v210831.please-select-a-reasonable-time")));
    } else {
      callback();
    }
  };
  couponFormRules = {
    activityName: [
      { required: true, message: t("v210831.please-enter-coupon"), trigger: "blur" },
      { min: 1, max: 14, message: t("v210831.the-length-is-1-14"), trigger: "blur" }
    ],
    activityBegin: [{ required: true, validator: this.endTiemVerify, trigger: "change" }],
    activityEnd: [{ required: true, validator: this.endTiemVerify, trigger: "change" }],
    totalQuantity: [{ required: true, validator: this.multipleTotalQuantity, trigger: "blur" }],
    radioNumber: [{ validator: this.radioNumberRule, trigger: "change" }],
    radioNumberYuan: [{ validator: this.radioNumberRuleYuan, trigger: "blur" }],
    limitAmount: [{ validator: this.doorsillYuan, trigger: "change" }],
    slectedParts: [{ validator: this.multipleValueArr, trigger: "change" }],
    multipleProject: [{ validator: this.multipleProjectArr, trigger: "change" }],
    storeTypeList: [
      { required: true, type: "array", trigger: "change", message: t("v270.please-select-a-sync-store") }
    ],
    time: { type: "array", required: true, message: t("v210831.please-select-a-reasonable-time"), trigger: "change" }
  };
  //计算属性
  get breadData() {
    return [
      { name: t("marketing.discount-coupon"), path: "/marketing/discount-coupon" },
      { name: this.$route.params.code ? t("v210831.edit-coupon") : t("marketing.created-coupon") }
    ];
  }
  get filterUserData() {
    return this.userData.storeList.filter(item => {
      return item.orgCode === this.selectedOrgCode;
    });
  }
  get copyCode() {
    return this.$route.query.copyCode;
  }
  get isAdd() {
    return this.$route.name === "marketingCreatedCouponAdd";
  }
  get editCode() {
    return this.$route.params.code;
  }
  created() {
    this.pushAction();
  }
  mounted() {
    this.init();
  }
  couponInfoSet(couponInfo, type?) {
    const {
      couponType,
      activityName,
      activityBegin,
      activityEnd,
      totalQuantity,
      activityDesc,
      rewardType,
      rewardValue,
      productDetails,
      limitAmount,
      activityCode,
      storeTypeList
    } = couponInfo;
    this.couponForm.time = [dayjs(activityBegin).format("YYYYMMDDHHmmss"), dayjs(activityEnd).format("YYYYMMDDHHmmss")];
    this.active = this.couponType[couponType];
    this.couponForm.activityName = activityName;
    this.couponForm.activityBegin = activityBegin;
    this.couponForm.activityEnd = activityEnd;
    this.couponForm.totalQuantity = totalQuantity;
    this.couponForm.activityDesc = activityDesc;
    this.couponForm.rewardType = rewardType;
    this.couponForm.limitAmount = limitAmount;
    this.couponForm.storeTypeList = storeTypeList;
    this.couponForm.activityCode = this.$route.params.copyRow ? null : activityCode; // 空为修改
    if (rewardType === "0401") {
      this.couponForm.radioNumberYuan = rewardValue;
    } else {
      this.couponForm.radioNumber = rewardValue.replace(".", "") / 10;
    }
    if (couponType === "0201" || couponType === "0202") {
      this.couponForm.slectedParts = productDetails.map(item => {
        if (!this.partsOptions.some(parts => parts.value === item.productCode)) {
          this.partsOptions.push({
            label: item.productName,
            value: item.productCode
          });
        }
        return {
          label: item.productName,
          value: item.productCode
        };
      });
    } else if (couponType === "0301") {
      this.couponForm.multipleProject = productDetails.map(item => {
        if (!this.project.some(service => service.value === item.productCode)) {
          this.project.push({
            label: item.productName,
            value: item.productCode
          });
        }
        return {
          label: item.productName,
          value: item.productCode
        };
      });
    }
    if (this.copyCode || type === "quote") {
      this.couponForm.activityCode = "";
    }
  }
  pushAction() {
    this.createCouponMethodList = [
      this.orderUnconditional,
      this.orderReachedAmount,
      this.productUnconditional,
      this.productReachedAmount,
      this.serviceUnconditional
    ];
  }
  storeTypeList: any = [];
  async init() {
    if (appCode === "speedbiz-operation") {
      this.getDictionaryList("store_type").then(data => {
        this.storeTypeList = data;
      });
    } else if (appCode === "speedbiz") {
      this.queryOpCouponList({
        pageSize: 999,
        pageNum: 1
      }).then(data => {
        this.opCouponList = data.data.list;
        if (this.autoPopOpTemplate && this.opCouponList.length > 0 && this.isAdd && !this.copyCode) {
          this.showSelectOpTemplate = true;
        }
      });
    }
    if (!this.isAdd || this.copyCode) {
      let code = this.editCode || this.copyCode;
      this.getDetail({ activityCode: code }).then(res => {
        this.couponInfoSet(res.data);
        this.mapPartsList();
        this.mapService();
      });
    } else {
      this.mapPartsList();
      this.mapService();
    }
  }
  mapService() {
    return this.queryServiceItemList({
      ...this.searchData,
      pageNum: 1,
      pageSize: 20,
      storeTypeArray: this.couponForm.storeTypeList
    }).then(res => {
      let mapParts =
        res.data.list &&
        res.data.list.map(item => {
          return {
            label: item.serviceName,
            value: item.serviceCode
          };
        });
      this.project = mapParts;
      this.loading = false;
    });
  }
  mapPartsList() {
    return this.getPartsList({
      ...this.searchData,
      pageNum: 1,
      pageSize: 20,
      syncStatus: "10",
      storeTypeArray: this.couponForm.storeTypeList
    }).then(res => {
      let mapParts = this.$safeValue(res, "data.list", []).map(item => {
        return {
          label: item.partsNameDesc || item.partsName,
          value: item.partsCode
        };
      });
      this.partsOptions = mapParts;
      this.loading = false;
    });
  }
  clickItem(item, index) {
    this.active = index;
    const form = this.$refs.couponForm as any;
    form.resetFields();
    this.couponForm.slectedParts = [];
    this.couponForm.multipleProject = [];
    this.couponForm.couponType = this.couponTypeArr[index];
  }
  iAmSure(formName) {
    const form = this.$refs[formName] as any;
    form.validate((valid, obj) => {
      if (valid) {
        this.couponForm.activityBegin = this.couponForm.time[0];
        this.couponForm.activityEnd = this.couponForm.time[1];
        if (dayjs(this.couponForm.time[1]).toDate().getTime() < Date.now()) {
          return this.$message.error(t("v210801.end-time-cannot"));
        }
        if (this.couponForm.radioNumber) {
          let noDot = Number(this.couponForm.radioNumber).toFixed(2);
          noDot = noDot.replace(".", "");
          this.couponForm.rewardValue = (Number(noDot) / 1000).toFixed(2) + "";
        } else {
          this.couponForm.rewardValue = this.couponForm.radioNumberYuan;
        }
        if (this.couponForm.slectedParts.length) {
          this.couponForm.productDetails = this.couponForm.slectedParts.map(item => {
            return {
              productCode: item.value,
              productName: item.label
            };
          });
        } else if (this.couponForm.multipleProject.length) {
          this.couponForm.productDetails = this.couponForm.multipleProject.map(item => {
            return {
              productCode: item.value,
              productName: item.label
            };
          });
        }
        this.requestCoupon();
      } else {
        console.log("error submit!!", obj);
        return false;
      }
    });
  }
  // 请求创建优惠券
  requestCoupon() {
    this.createCouponMethodList[this.active]({
      ...this.couponForm
    }).then(() => {
      this.$message.success(t("v210831.coupon-saved"));
      this.$router.push("/marketing/discount-coupon");
    });
  }
  remoteMethodParts(query) {
    this.searchData.searchKey = query;
    this.loading = true;
    // 请求后台
    this.mapPartsList();
  }
  remoteMethodService(query) {
    this.searchData.searchKey = query;
    this.loading = true;
    // 请求后台
    this.mapService();
  }
  pickerOptions = {
    disabledDate(time) {
      return time.getTime() < Date.now();
    }
  };
  selectedTemp: any = {};
  handleTempClick(coupon) {
    this.selectedTemp = coupon;
  }
  handleStoreChange() {
    this.couponForm.slectedParts = [];
    this.couponForm.multipleProject = [];
    this.mapService();
    this.mapPartsList();
  }
}
